var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 458,
    viewBox: "0 0 848 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_36193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849 0L793.833 24C738.667 48 628.333 96 518 96C407.667 96 297.333 48 187 36C76.6667 24 -33.6666 48 -144 54C-254.333 60 -364.667 48 -419.833 42L-475 36V288H-419.833C-364.667 288 -254.333 288 -144 288C-33.6666 288 76.6667 288 187 288C297.333 288 407.667 288 518 288C628.333 288 738.667 288 793.833 288H849V0Z",
    fill: "#993333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941 198.625L913.115 186.116C884.385 173.607 828.615 148.589 772 131.911C715.385 115.232 659.615 106.893 603 111.063C546.385 115.232 490.615 131.911 434 144.42C377.385 156.929 321.615 165.268 265 165.268C208.385 165.268 152.615 156.929 95.9999 148.589C39.3849 140.25 -16.385 131.911 -45.115 127.741L-73 123.572V292H-45.115C-16.385 292 39.3849 292 95.9999 292C152.615 292 208.385 292 265 292C321.615 292 377.385 292 434 292C490.615 292 546.385 292 603 292C659.615 292 715.385 292 772 292C828.615 292 884.385 292 913.115 292H941V198.625Z",
    fill: "#972020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-217 268.709L-191.238 262.699C-166.365 256.689 -115.73 244.67 -65.095 226.641C-13.5717 208.612 37.0633 184.573 87.6983 178.563C138.333 172.554 188.968 184.573 239.603 202.602C290.238 220.631 341.762 244.67 392.397 262.699C443.032 280.728 493.667 292.748 544.302 292.748C594.937 292.748 645.572 280.728 697.095 274.719C747.73 268.709 798.365 268.709 823.238 268.709H849V449H823.238C798.365 449 747.73 449 697.095 449C645.572 449 594.937 449 544.302 449C493.667 449 443.032 449 392.397 449C341.762 449 290.238 449 239.603 449C188.968 449 138.333 449 87.6983 449C37.0633 449 -13.5717 449 -65.095 449C-115.73 449 -166.365 449 -191.238 449H-217V268.709Z",
    fill: "#931010"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-407 144H-354.667C-302.333 144 -197.667 144 -93 186C11.6667 228 116.333 312 221 336C325.667 360 430.333 324 535 282C639.667 240 744.333 192 796.667 168L849 144V468H796.667C744.333 468 639.667 468 535 468C430.333 468 325.667 468 221 468C116.333 468 11.6667 468 -93 468C-197.667 468 -302.333 468 -354.667 468H-407V144Z",
    fill: "#8D0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_36193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 848,
    height: 458,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background.cc5f0958d9225fdf59218fbdddef0b42.svg";